import React, { FunctionComponent, useCallback, useEffect } from 'react';
import {
  colesContactCenter,
  customerCareNumber,
  format1300Number,
  insuranceBaseUrl,
} from 'scenes/common/helpers/contacts';
import { Heading, Text } from 'components/chroma';
import { useSelector } from 'react-redux';
import { getPaymentState } from 'scenes/payments/redux/payment/selectors';
import { WireProduct } from 'scenes/common/api/quote/types';
import { Unknown as MotorImage } from 'scenes/motor/components/Error/components';
import { Unknown as DwellingImage } from 'scenes/landlord/components/Error/components';
import { ErrorPage } from 'scenes/common/components/Error';
import { History } from 'history';
import { useHistory } from 'react-router';
import useNextPage from 'scenes/payments/hooks';
import { onBackGoToLanding } from 'scenes/payments/routes';

const errorPageData = (product: WireProduct) => ({
  Header: () => <Heading>We’re feeling a little under the weather!</Heading>,
  Image:
    product === WireProduct.Motor
      ? () => <MotorImage />
      : () => <DwellingImage />,
  Content: () => (
    <>
      <Text>
        We&#39;re sorry, we&#39;ve encountered an error and are unable to
        process your request at this time. <br />
        Please try again later or call us on{' '}
        <strong>{format1300Number(customerCareNumber())}</strong> for
        assistance. Our contact hours can be found{' '}
        <a
          href={colesContactCenter()}
          target="_blank"
          rel="noopener noreferrer"
        >
          here
        </a>
        .
      </Text>
      <Text>
        Return to the{' '}
        <a href={insuranceBaseUrl()} target="_blank" rel="noopener noreferrer">
          Coles Insurance home page
        </a>
      </Text>
    </>
  ),
  ShowNewQuote: false,
});

export const SystemErrorPage: FunctionComponent = () => {
  const paymentState = useSelector(getPaymentState);
  const { Header, Image, Content, ShowNewQuote } = errorPageData(
    paymentState.product
  );

  const history: History = useHistory();
  const nextPage = useNextPage();
  const restartQuote = useCallback(() => nextPage(), [nextPage]);

  useEffect(() => {
    onBackGoToLanding(history);
  }, [history]);

  return (
    <ErrorPage
      Header={Header}
      Image={Image}
      Content={Content}
      showNewQuote={ShowNewQuote}
      onRestartQuote={restartQuote}
    />
  );
};

export default SystemErrorPage;
